import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateSickLeaveForm } from "../../../components/create-sick-leave-form";

export const SickLeaveCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin nghỉ ốm/nuôi con ốm">
      <CreateSickLeaveForm />
    </ProcedureLayout>
  );
});
